import { graphql } from 'gql'

export const DEACTIVATE_ALL_AD_UNITS_PRODUCT = graphql(`
  mutation deactivateAllAdUnitsProduct($input: DeactivateAllAdUnitsProductInput!) {
    deactivateAllAdUnitsProduct(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`)
